/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Meta_DescriptionInputs */

const en_road_dude_meta_description = /** @type {(inputs: Road_Dude_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Hit the Road Dude AI video examples, learn where the State Property meme started, and make a pickup-truck remix with a photo and a ready-to-use prompt.`)
};

const zh_road_dude_meta_description = /** @type {(inputs: Road_Dude_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解 Hit the Road Dude AI 私人领地梗的出处，观看狗狗、猫咪和人物皮卡翻拍案例，并用一张照片和现成提示词制作自己的版本。`)
};

/**
* | output |
* | --- |
* | "Watch Hit the Road Dude AI video examples, learn where the State Property meme started, and make a pickup-truck remix with a photo and a ready-to-use prompt." |
*
* @param {Road_Dude_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_meta_description = /** @type {((inputs?: Road_Dude_Meta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Meta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_meta_description(inputs)
	return zh_road_dude_meta_description(inputs)
});
export { road_dude_meta_description as "road_dude.meta.description" }